import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { BadgeColorsEnum } from 'src/app/shared/interfaces/BadgeColorsEnum';
import { PinService } from 'src/app/shared/services/pin.service';
import { ToggleCompounding } from 'src/app/shared/states/pharmacy/pharmacy.actions';
import { PharmacyState } from 'src/app/shared/states/pharmacy/pharmacy.state';

@UntilDestroy()
@Component({
  selector: 'app-compounding',
  templateUrl: './compounding.component.html',
  styleUrls: ['./compounding.component.scss', '../../settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompoundingComponent implements OnInit{

  @Select(PharmacyState.compoundingEnabled) compoundingEnabled$: Observable<boolean>;

  private pinChannel = 'toggleCompounding';
  BadgeColorsEnum = BadgeColorsEnum;
  /**
   *
   */
  constructor(private store: Store, private pinService: PinService, private cdr: ChangeDetectorRef) {}
  
  ngOnInit(): void {
    this.pinService.validatePin$
    .pipe(untilDestroyed(this))
    .subscribe(res => {
      if (res?.success && res.dialogId === this.pinChannel) {
        this.toggleSettingRequest(res.pin);
      }
    });
  }


  onSwitchClick(): void {
    this.pinService.openPinDialog(this.pinChannel);
  }

  private toggleSettingRequest(pin: number): void {
    this.store.dispatch(new ToggleCompounding(pin))
    .pipe(untilDestroyed(this))
    .subscribe(() => {
      this.pinService.closeDialog();
      this.cdr.markForCheck();
    })
  }
}
